const TOKEN =  '@$';

export {
    TOKEN
}